import { gql } from "@apollo/client";

export const GET_ALL_ESTADOS = gql`
query GetAllEstados {
    allTraditumEstado {
        idEstado,
        estado,
        observacion
    }
}`;
export const adaptEstado = (estado) => {
  return {
    id: estado?.idEstado,
    displayName: estado?.estado
  };
};

export const adaptTraditumEstadosArray = (
allTraditumEstado) =>
{
  return structuredClone(allTraditumEstado)?.
  map((estado) => adaptEstado(estado));
};